export const fieldTypes = {
  select: 'select',
  text: 'text',
  number: 'number',
  datetime: 'datetime',
}
